import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { AllocationViewAvailableDocksModel } from '../models/allocation-view-available-docks.model';
import { AllocationViewEndpoint } from '../constants/allocation-view-endpoint';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewAvailableDocksService {
  constructor(private http: WrapperHttpService) {}

  getAllocationViewAvailableDocks(hubId: number): Observable<AllocationViewAvailableDocksModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Base}/${hubId}${AllocationViewEndpoint.Filter}${AllocationViewEndpoint.Available}`;
    return this.http.withLoading().get<AllocationViewAvailableDocksModel>(url);
  }
}
